var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSocialFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.7327 5.54401C26.7327 3.33201 24.7167 1.31601 22.5047 1.31601H5.56475C3.35275 1.31601 1.33675 3.33201 1.33675 5.54401V22.484C1.33675 24.696 3.35275 26.712 5.56475 26.712H14.0207V17.108H10.9127V12.88H14.0207V11.228C14.0207 8.37201 16.1487 5.82401 18.7807 5.82401H22.1967V10.052H18.7807C18.4167 10.052 17.9687 10.5 17.9687 11.2V12.88H22.1967V17.108H17.9687V26.712H22.4767C24.6887 26.712 26.7047 24.696 26.7047 22.484V5.54401H26.7327Z",
    fill: "#476A89"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSocialFacebook);
export default __webpack_public_path__ + "static/media/icon-social-facebook.d012000d62c7e148ff4364f71525004f.svg";
export { ForwardRef as ReactComponent };